var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rotate-180",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.59,
    height: 18,
    viewBox: "0 0 17.59 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M13.893,29.619l-.241,1.373a9,9,0,0,1-2.959-1.076l.7-1.208a7.613,7.613,0,0,0,2.5.911Z",
    transform: "translate(-6.153 -12.993)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M6.908,24.538l-1.069.9a9.059,9.059,0,0,1-1.57-2.729l1.31-.478a7.663,7.663,0,0,0,1.329,2.31Z",
    transform: "translate(-3.714 -10.533)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M23.348,29.917a9,9,0,0,1-2.959,1.076l-.242-1.373a7.613,7.613,0,0,0,2.5-.911Z",
    transform: "translate(-9.743 -12.993)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M28.805,22.228l1.311.476a9.059,9.059,0,0,1-1.57,2.729l-.217-.182-.852-.715a7.664,7.664,0,0,0,1.328-2.31Z",
    transform: "translate(-12.526 -10.532)",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M10.816,4.949c-.112.024-.22.056-.329.084q-.223.057-.442.128c-.114.038-.227.081-.339.124-.135.051-.267.1-.4.164-.112.05-.223.1-.332.161q-.187.095-.367.2C8.5,5.872,8.4,5.935,8.292,6s-.23.156-.343.239-.2.141-.291.218c-.112.091-.22.187-.328.283-.085.077-.173.151-.255.231-.117.114-.225.236-.334.357a7.637,7.637,0,0,0-1.97,5.116h-1.4A9.028,9.028,0,0,1,5.5,6.62l0,0c.064-.077.138-.144.2-.218.128-.143.256-.286.393-.421.1-.095.2-.183.3-.273.128-.115.256-.23.39-.336.112-.089.227-.172.342-.256.134-.1.269-.194.408-.283.122-.079.246-.153.372-.226q.216-.125.437-.238c.128-.066.258-.129.391-.189.155-.07.313-.133.473-.2.133-.05.264-.1.4-.145.172-.057.347-.1.524-.151.13-.034.257-.071.388-.1.2-.044.409-.074.617-.1.111-.016.219-.039.331-.051a9.026,9.026,0,0,1,7.958,3.228V4.073h1.4V9.655H15.239V8.26H18.86A7.649,7.649,0,0,0,12.447,4.77a7.754,7.754,0,0,0-.83.047c-.095.011-.187.029-.281.043-.174.026-.35.052-.52.089Z",
    transform: "translate(-3.375 -3.374)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.d67af71b2e486f3e99fd1a0a961ce94f.svg";
export { ForwardRef as ReactComponent };